import { Component, EventEmitter, Input, Output, signal } from '@angular/core';
import { ButtonModule } from 'primeng/button';
import { Tooltip } from 'primeng/tooltip';
import { Blueprint } from '../../../../../../../models/blueprint.model';
import { BlueprintsSelectorComponent } from '../../../../../../blueprints-viewer/blueprints-selector.component';

@Component({
  selector: 'app-quote-item-select-template',
  imports: [ButtonModule, BlueprintsSelectorComponent, Tooltip],
  templateUrl: './quote-item-select-template.component.html',
  styleUrl: './quote-item-select-template.component.scss',
})
export class QuoteItemSelectTemplateComponent {
  @Input() allBlueprints: Blueprint[] = [];
  @Input() showSkip = true;
  @Input() nextLabel = 'Next';
  @Input() nextIcon = 'pi pi-arrow-right';

  @Output() blueprintSelected = new EventEmitter<Blueprint | null>();
  @Output() next = new EventEmitter<void>();
  @Output() back = new EventEmitter<void>();
  @Output() skip = new EventEmitter<void>();

  selectedBlueprint = signal<Blueprint | null>(null);

  onBlueprintSelection(blueprint: Blueprint | null): void {
    this.selectedBlueprint.set(blueprint);
    this.blueprintSelected.emit(blueprint);
  }

  onBack(): void {
    this.selectedBlueprint.set(null);
    this.blueprintSelected.emit(null);
    this.back.emit();
  }
}
